import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { CommonService } from 'src/app/shared/utils/common.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { PageName } from 'src/app/shared/utils/user-roles';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-add-user-group',
  templateUrl: './add-user-group.component.html',
  styleUrls: ['./add-user-group.component.scss'],
})
export class AddUserGroupComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @ViewChild('userGroup', { static: false }) userGroup: ElementRef | undefined;

  @Input() isEditMode!: boolean;
  @Input() buildingList: any;
  @Output() removeUserGroup = new EventEmitter<string>();

  formGroup!: FormGroup;

  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  readonly PageName = PageName;
  isDefault = false;
  constructor(
    private rootFormGroup: FormGroupDirective,
    public commonService: CommonService,
    private elementRef: ElementRef,
    private localizationService: LocalizationService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.formGroup = this.rootFormGroup?.control?.get(
      this.formGroupName
    ) as FormGroup;
    this.isDefault = this.formGroup.controls.isDefault.value;
    if (this.isDefault) {
      this.formInstance.name?.disable();
      this.formInstance.description?.disable();
    } else {
      this.formInstance.name?.enable();
      this.formInstance.description?.enable();
    }
  }
  /**
   * @description get form instance
   * @returns form controls
   */
  get formInstance() {
    return this.formGroup.controls;
  }

  navigateBack() {
    //before back reset id
    this.formGroup.patchValue({
      id: null,
      description: null,
      name: null,
      isDefault: null,
    });
    this.stepper--;
    this.stepperChange.emit(this.stepper);
    this.buildingList?.forEach((building: any) => {
      building.buildingCount = 0;
    });
  }

  addUserGroup() {
    this.formGroup.markAllAsTouched();
    if (!this.formGroup.valid) return;
    this.stepper++;
    this.stepperChange.emit(this.stepper);
  }
  @HostListener('document:keydown.enter')
  onEnterKeyDown(): void {
    const userGroup = this.elementRef.nativeElement.querySelector('#userGroup');
    if (userGroup) {
      userGroup.focus();
    }
  }

  onRemoveGroup() {
    this.removeUserGroup.emit();
  }
}
